var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('postal-upload-header',{attrs:{"page-name":"郵便番号CSV(upload)"}}),_vm._v(" "),_c('postal-upload-content'),_vm._v(" "),_c('postal-file-select',{attrs:{"has-header":"","ext":['csv','CSV'],"act":"importPostalCsv"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }